import React from 'react'
import styles from '../styles/AdBlock.module.scss'
import cn from 'classnames'
import { Footer } from './Footer'

interface AdBlockProps {
  stepIsMood: boolean
}

export const AdBlock: React.FC<AdBlockProps> = ({ stepIsMood }) => {

  return (
    <div className={styles.ad_wrapper}>
      <h2 className={cn(styles.ad_text)}>
        Are you a business owner?
      </h2>

      <p className={styles.ad_text}>
        Start using yesloyal links and Instant Reviews completely free!
      </p>

      <a href='https://yesl.io/r/ylb_ir_get_started'
        target='_blank'
        rel="noreferrer"
        className={styles.ad_link}
      >
        Get Started with yesloyal now
      </a>

      <Footer stepIsMood={stepIsMood} />
    </div>
  )
}